import KeyMirror from 'keymirror'

export const TENDER_NUMBER_TYPE = KeyMirror({
  PO: null,
  CONTRACT: null,
})

export const TENDER_TYPES_MAP = {
  PO: 'purchaseOrders',
  CONTRACT: 'contracts',
}

export const TENDER_CONDITIONS_OF_CONTRACTS = 'TENDER_CONDITIONS_OF_CONTRACTS'

export const TENDER_UNITS = [
  'ft', 'ft'.concat(String.fromCharCode(178)), 'kg', 'lb', 'Litre', 'Lot', 'm', 'm'.concat(String.fromCharCode(178)),
  'Man Day', 'Man Hour', 'No.', 'Pack', 'Roll', 'Set', 'Sum', 'Yard',
]

export const KEEP_EDIT_REQUEST_GAP_SECS = 30
